import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
/**
 * Copilot V2 message generators. These lived in chatspot-core for V1, but we don't have
 * access to the generated CHIRP types there for V2.
 */

const portalId = PortalIdParser.get();
let incrementingId = 0;

// TODO: Find a more scalable way to keep this up to date with generated types in CopilotThreadsService.ts
const defaultEmptyPayload = {
  __typename: 'com.hubspot.copilot.models.chat.payload.EmptyPayload'
};
export const createCopilotMessage = ({
  threadId,
  interactionId,
  sections
}) => ({
  id: `copilot-message-${incrementingId++}`,
  portalId: portalId !== null && portalId !== void 0 ? portalId : 0,
  threadId,
  messageType: 'COPILOT',
  interactionId,
  modelRequestIds: [],
  timestamp: 0,
  sections,
  correlationId: '',
  agentPayload: defaultEmptyPayload
});
export const createUserMessage = ({
  message,
  threadId,
  interactionId
}) => ({
  id: `user-message-${incrementingId++}`,
  portalId: portalId !== null && portalId !== void 0 ? portalId : 0,
  threadId: threadId !== null && threadId !== void 0 ? threadId : 0,
  messageType: 'USER',
  interactionId: interactionId !== null && interactionId !== void 0 ? interactionId : `user-message-interaction-${incrementingId++}`,
  modelRequestIds: [],
  timestamp: 0,
  sections: [{
    id: '',
    text: message,
    type: 'USER_CHAT',
    __typename: 'com.hubspot.chatspot.message.schemas.sections.UserChatResponseSection'
  }],
  correlationId: '',
  agentPayload: defaultEmptyPayload
});
export const createDurationMessage = ({
  duration,
  threadId,
  interactionId
}) => ({
  id: `duration-message-${incrementingId++}`,
  portalId: portalId !== null && portalId !== void 0 ? portalId : 0,
  threadId,
  messageType: 'COPILOT',
  interactionId,
  modelRequestIds: [],
  timestamp: 0,
  sections: [{
    id: '',
    text: `<small>${I18n.text(`reasoningMessage.duration`, {
      duration: Math.round(duration / 1000)
    })}</small>`,
    type: 'LLM'
  }],
  correlationId: '',
  agentPayload: defaultEmptyPayload
});
export const createSystemMessage = ({
  message,
  threadId,
  interactionId
}) => ({
  id: `system-message-${incrementingId++}`,
  portalId: portalId !== null && portalId !== void 0 ? portalId : 0,
  threadId: threadId !== null && threadId !== void 0 ? threadId : 0,
  messageType: 'COPILOT',
  interactionId: interactionId !== null && interactionId !== void 0 ? interactionId : `system-message-interaction-${incrementingId++}`,
  modelRequestIds: [],
  timestamp: Date.now(),
  sections: [{
    __typename: 'com.hubspot.chatspot.message.schemas.sections.PlainTextResponseSection',
    id: `system-message-section-${incrementingId++}`,
    text: message,
    type: 'PLAIN_TEXT'
  }],
  agentPayload: defaultEmptyPayload
});

/**
 * @temporary This utility is used for creating action exception message when we call a V1 action that is not supported in V2.
 * @expiration 2025-08-15
 * @deprecated
 * This happens when a valid V1 action cannot be translated to a V2 tool call
 */
export const createActionExceptionMessage = ({
  threadId,
  interactionId
}) => ({
  id: `action-exception-message-${incrementingId++}`,
  portalId: portalId !== null && portalId !== void 0 ? portalId : 0,
  threadId: threadId !== null && threadId !== void 0 ? threadId : 0,
  messageType: 'COPILOT',
  interactionId,
  modelRequestIds: [],
  timestamp: Date.now(),
  sections: [{
    __typename: 'com.hubspot.chatspot.message.schemas.sections.LlmResponseSection',
    id: `action-exception-message-section-${incrementingId++}`,
    text: I18n.text('messageActions.exception.message'),
    type: 'LLM'
  }],
  agentPayload: defaultEmptyPayload
});
export const createErrorMessage = ({
  interactionId,
  section,
  threadId
}) => {
  return {
    id: `response-exception-message-${incrementingId++}`,
    portalId: portalId !== null && portalId !== void 0 ? portalId : 0,
    threadId: threadId !== null && threadId !== void 0 ? threadId : 0,
    messageType: 'COPILOT',
    interactionId,
    modelRequestIds: [],
    timestamp: Date.now(),
    sections: [Object.assign({}, section, {
      __typename: 'com.hubspot.chatspot.message.schemas.sections.LlmResponseSection',
      id: `response-exception-message-section-${incrementingId++}`
    })],
    agentPayload: defaultEmptyPayload
  };
};

/**
 * Helper function to determine if a message is a system message created by createSystemMessage
 */
export const isSystemMessage = message => {
  return message.id.startsWith('system-message-');
};

/**
 * Helper function to determine if an interaction contains only system messages
 */
export const isSystemInteraction = messages => {
  return messages.length > 0 && messages.every(isSystemMessage);
};